"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTokenNode = exports.NodeType = void 0;
var NodeType;
exports.NodeType = NodeType;

(function (NodeType) {
  NodeType["statement"] = "statement";
  NodeType["clause"] = "clause";
  NodeType["binary_clause"] = "binary_clause";
  NodeType["function_call"] = "function_call";
  NodeType["array_subscript"] = "array_subscript";
  NodeType["parenthesis"] = "parenthesis";
  NodeType["between_predicate"] = "between_predicate";
  NodeType["limit_clause"] = "limit_clause";
  NodeType["all_columns_asterisk"] = "all_columns_asterisk";
  NodeType["token"] = "token";
})(NodeType || (exports.NodeType = NodeType = {}));

var isTokenNode = function isTokenNode(node) {
  return node.type === 'token';
};

exports.isTokenNode = isTokenNode;
//# sourceMappingURL=ast.js.map